module.exports = function () {
  return new Worker(__webpack_public_path__ + "aa43011cc745257580ca.worker.js");
};